<template>
  <el-dialog
    :title="$t('config.profile.title.mergeDialog')"
    :visible.sync="mergeTableVisible"
    width="70%"
    :close-on-click-modal="false"
  >
    <MergeDataTable
      v-model="resultData"
      :selected-list="selectedList"
      id-header="id"
      @onMerge="onMergeProfile"
    />
    <!-- <div>{{ selectedList }}</div> -->

    <span slot="footer" class="dialog-footer">
      <div class="button-containers">
        <button
          class="btn primary small outline"
          @click="mergeTableVisible = false"
        >
          {{ $t('config.profile.common.cancel') }}
        </button>
        <button class="btn primary small" @click="onMergeProfile">
          {{ $t('config.profile.common.agree') }}
        </button>
      </div>
    </span>
  </el-dialog>
</template>

<script>
import MergeDataTable from '../../components/MergeDataTable.vue'

import { mergeProfieApi } from '@/api/configuration/profile/agent'

export default {
  components: { MergeDataTable },
  props: {
    value: {
      type: Boolean,
      default: false
    },
    selectedList: {
      type: Array,
      default: () => []
    }
  },
  data: function () {
    return {
      mergeTableVisible: this.value,
      resultData: null
    }
  },

  watch: {
    value(nv, ov) {
      this.mergeTableVisible = nv
    },
    mergeTableVisible(nv, ov) {
      if (!nv) {
        this.$emit('input', nv)
      }
    }
  },

  mounted() {},

  methods: {
    onMergeProfile() {
      this.resultData = {
        ...this.resultData,
        id: this.selectedList[0].id,
        id_to_merge: this.selectedList
          .map((item, index) => {
            if (index === 0) return null
            else return item.id
          })
          .slice(1)
      }
      if (this.resultData) {
        // call api merge and refresh
        mergeProfieApi(this.resultData)
          .then(data => {
            if (!data.is_error) {
              this.$message({
                type: 'success',
                message: this.$t(`successMsg.${data.message}`)
              })
              // close dialog
              this.mergeTableVisible = false
              this.$emit('resetSearch')
            } else {
              throw new Error(data)
            }
          })
          .catch(error => {
            const message = error.response?.data?.message || 'default'
            this.$message({
              type: 'error',
              message: this.$t(`errorMsg.${message}`)
            })
          })
          .finally(() => {})
      }
    }
  }
}
</script>
